import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const bedtimeAge2: BlogMetaData = {
  title: '2歳の寝かしつけ｜イヤイヤ期で寝ない・寝るのを嫌がる原因とモンテッソーリ流の対応',
  description:
    '2歳の寝かしつけがうまくいかない…。イヤイヤ期で寝ない・寝るのを嫌がる背景には自我の芽生えや昼寝・刺激のバランスがあります。夜寝ない2歳児に試したいモンテッソーリ流の対応を、自己選択と秩序の敏感期の視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-bedtime-age-2.webp',
  filePath: buildBlogFilePath('bedtime-age-2'),
  category: BLOG_CATEGORY.PARENTING,
};
